import { CardGroup } from "react-bootstrap";
import Card, { CardItem } from './Card';
import { ReactNode, useEffect, useState } from "react";
import CardSplice from "../../helpers/CardSplice";

type Props = {
    id: string;
    cards: Array<CardItem>;
    columns?: number;
    cardBody: (card: CardItem) => ReactNode;
}

export default function CustomCardGroup(props: Props) {
    const {id, cards, cardBody, columns = 0} = props;
    const [cardColumns, setCardColumns] = useState<Array<CardItem[]|never>>([]);

    useEffect(() => {
        if (columns > 0) {
            setCardColumns(CardSplice(cards, columns));
        }
    }, [cards, columns, setCardColumns]);

    return cards.length ? (columns === 0  ? (
        <CardGroup id={id}>
            <Card id={`${id}_card`} cards={cards} cardBody={cardBody} />
        </CardGroup>
    ) : (
            <>
                {cardColumns.map((column: CardItem[], index: number) => {
                    return <CardGroup key={index} id={`${id}_${String(index)}`}>
                        <Card id={`${id}_card_${String(index)}`} cards={column} cardBody={cardBody} />
                    </CardGroup>
                })}
            </>
        )
    ) : <div className="text-center py-4">Nessuna card da visualizzare</div>
}